import { Helmet } from 'react-helmet-async';

const BASE_URL = 'https://voxsmyth.com';
const DEFAULT_IMAGE = `${BASE_URL}/og-card.png`;
const SITE_NAME = 'VoxSmyth';

/**
 * SEO head component — sets title, meta description, OG tags, canonical URL per page.
 * Usage: <PageSEO title="Voices" description="Browse 65+ AI voices" path="/voices" />
 */
const PageSEO = ({ title, description, path = '/', image, type = 'website', noindex = false }) => {
  const fullTitle = title ? `${title} | ${SITE_NAME}` : `${SITE_NAME} - AI Audiobook Narration`;
  const fullUrl = `${BASE_URL}${path}`;
  const ogImage = image || DEFAULT_IMAGE;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={fullUrl} />
      {noindex && <meta name="robots" content="noindex, nofollow" />}

      {/* Open Graph */}
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={fullUrl} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:type" content={type} />
      <meta property="og:site_name" content={SITE_NAME} />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImage} />
    </Helmet>
  );
};

export default PageSEO;
